import { ensureImmutable, isImmutable } from '@/lib/data/utils';

import * as Chart from '@/lib/data/chart';

import {
  DEFAULT_MOBILE_CHART_HEIGHT,
  DEFAULT_MOBILE_CHART_WIDTH,
} from '@/lib/config';

// Check contextualize-ai.story/story-states.
export const STATES = {
  NEW: 'new',
  UNLISTED: 'unlisted',
  PUBLISHED: 'published',
  DELETED: 'deleted',
  ARCHIVED: 'archived',
};

export function state(storyOrStoryData) {
  return isImmutable(storyOrStoryData)
    ? storyOrStoryData.get('state')
    : storyOrStoryData.state;
}

export function isPublished(story) {
  return state(story) === STATES.PUBLISHED;
}

export function isOptimizedForMobile(storyOrStoryData) {
  const story = ensureImmutable(storyOrStoryData);

  return (
    story.getIn(['chart', 'properties', 'width']) ===
      DEFAULT_MOBILE_CHART_WIDTH &&
    story.getIn(['chart', 'properties', 'height']) ===
      DEFAULT_MOBILE_CHART_HEIGHT
  );
}

export function toggleStateBetweenUnlistedAndPublished(story) {
  return isPublished(story) ? STATES.UNLISTED : STATES.PUBLISHED;
}

export function makeSpec(story, options) {
  const chartSpec = Chart.makeSpec(story, options);

  const spec = {
    $schema: 'https://vega.github.io/schema/vega-lite/v5.json',
    padding: story.getIn(['chart', 'properties', 'padding']).toJS(),
    config: {
      // https://vega.github.io/vega-lite/docs/spec.html#view-background
      view: {
        stroke: 'transparent',
      },
      customFormatTypes: true,
    },
    ...chartSpec,
  };

  return spec;
}
